import { BannerActionKey } from '../types'

export const ZUI_EVENTS = {
  NAV_ITEM_CLICK: 'nav-item-click',
  WORKSPACE_CLICK: 'workspace-click',
  HELP_MENU_ITEM_CLICK: 'help-menu-item-click',
  SUBNAV_ITEM_CLICK: 'subnav-item-click',
  SUBNAV_ITEM_ACTION_CLICK: 'subnav-item-action-click',
  PROFILE_MENU_CLICK: 'profile-menu-click',
  SUBNAV_EXTRA_CLICK: 'subnav-extra-click',
  SUBNAV_ACTION_CLICK: 'subnav-action-click',
  BANNER_CLICK: 'banner-click',
  SEARCH_QUERY_CHANGE: 'search-query-change',
  SEARCH_RESULT_SELECT: 'search-result-select',
  CLEAR_ASSETS_OVERRIDE: 'clear-assets-override',
} as const

type EventDetail = {
  [ZUI_EVENTS.NAV_ITEM_CLICK]: { key: string }
  [ZUI_EVENTS.WORKSPACE_CLICK]: { id: string }
  [ZUI_EVENTS.HELP_MENU_ITEM_CLICK]: { key: string }
  [ZUI_EVENTS.PROFILE_MENU_CLICK]: { key: string }
  [ZUI_EVENTS.SUBNAV_ITEM_CLICK]: { navItem: string; subnavItem: string }
  [ZUI_EVENTS.SUBNAV_ITEM_ACTION_CLICK]: { navItem: string; subnavItem: string; action: string }
  [ZUI_EVENTS.SUBNAV_EXTRA_CLICK]: { navItem: string; extraItem: string } // extraitem: public_filters | private_filters | create assignment
  [ZUI_EVENTS.SUBNAV_ACTION_CLICK]: { key?: string }
  [ZUI_EVENTS.BANNER_CLICK]: { id: string; action: BannerActionKey }
  [ZUI_EVENTS.SEARCH_QUERY_CHANGE]: { query: string }
  [ZUI_EVENTS.SEARCH_RESULT_SELECT]: { type: 'route' | 'filter' | 'conversation'; id: string; data?: any }
  [ZUI_EVENTS.CLEAR_ASSETS_OVERRIDE]: Record<string, never>
}

export const dispatchZuiEvent = <T extends keyof EventDetail>(eventName: T, detail: EventDetail[T]): void => {
  // Emit custom event for parent components
  console.info('[ZUI] dispatch event log:', { eventName })
  const event = new CustomEvent(eventName, {
    detail,
    bubbles: true,
  })

  const customElement = document.querySelector('zui-navigation')

  if (customElement) {
    customElement.dispatchEvent(event)
  }
}
